document.addEventListener('alpine:init', () => {
  Alpine.store('mobileMenu', {
    get isOpen() {
      return this._isOpen;
    },
    set isOpen(value) {
      if (value) {
        window.scrollTo({ top: 0 });
      }

      this._isOpen = value;
    },
    _isOpen: false,

    toggle() {
      this.isOpen = !this.isOpen;
    },
  });
});